type PasswordValidationResult = {
  isValid: boolean;
  error: string;
};

export const validatePasswordField = (
  value: string,
): PasswordValidationResult => {
  const password = value ?? '';

  if (!password.trim()) {
    return { isValid: false, error: 'Поле пароля не может быть пустым' };
  }

  if (/\s/.test(password)) {
    return { isValid: false, error: 'Пароль не должен содержать пробелы' };
  }

  if (password.length < 6) {
    return { isValid: false, error: 'Минимальная длина пароля — 6 символов' };
  }

  return { isValid: true, error: '' };
};
